module.exports = __webpack_public_path__ + "img/eyes.07bdc251.svg";